module.exports = __webpack_public_path__ + "img/37913-093.a69e862a.jpg";